/** @see https://github.com/grail-ui/grail-ui/blob/100d79b9f263caf3a974c164773f9e69704fb079/packages/grail-ui/src/textareaAutosize/textareaAutosize.ts */
import type { Action } from 'svelte/action';
import { createResizeObserver } from '$lib/utils/resizeObserver';

export type TextareaAutosizeReturn = {
    /**
     * Action for the textarea that needs to be resized.
     */
    useTextareaAutosize: Action<HTMLTextAreaElement, void>;
};

export const createTextareaAutosize = (): TextareaAutosizeReturn => {
    const { useResizeObserver, entries } = createResizeObserver();

    const useTextareaAutosize = (node: HTMLTextAreaElement) => {
        function triggerResize() {
            node.style.height = 'auto';
            node.style.height = `${node.scrollHeight}px`;
        }

        const observer = useResizeObserver(node);
        entries.subscribe(() => {
            triggerResize();
        });

        node.addEventListener('input', triggerResize);

        return {
            destroy() {
                observer?.destroy?.();
                node.removeEventListener('input', triggerResize);
            },
        };
    };

    return {
        useTextareaAutosize,
    };
};
